import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';
import { BREAK_POINTS } from '@constants/common/breakpoints';

interface IModalProps extends ModalContextType {
    setActiveTab: (tab: number) => void;
}

const StyledControls = styled.div`
    @media (min-width: ${BREAK_POINTS.xs}) {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        justify-content: flex-end;
    }
`;

export default function HealthBeforeDentalModal({ closeModal, setActiveTab }: IModalProps) {
    function onClose(e?: React.MouseEvent<HTMLElement>) {
        e?.preventDefault();
        closeModal('healthBeforeDentalModal');
    }

    function onContinueWithHealth(e?: React.MouseEvent<HTMLElement>) {
        setActiveTab(0);
        onClose(e);
    }

    return (
        <Modal id="healthBeforeDentalModal">
            <Modal.Header id="healthBeforeDentalModalHeader" titleId="customGrouping.customGrouping" onHide={onContinueWithHealth} />
            <Modal.Body id="healthBeforeDentalModalBody">
                <p>
                    <FormattedMessage id="customGrouping.healthEnrollPriorDental" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <StyledControls>
                    <CapitalizedButton 
                        id="healthBeforeDentalModalContinueButton" 
                        variant="secondary" 
                        onClickHandler={onContinueWithHealth} 
                        labelId="customGrouping.continueWithHealth" 
                    />
                    <CapitalizedButton 
                        id="healthBeforeDentalModalStartButton" 
                        variant="secondary" 
                        onClickHandler={onClose} 
                        labelId="customGrouping.startDentalShopping" 
                    />
                </StyledControls>
            </Modal.Controls>
        </Modal>
    );
}
